import { createFileRoute } from "@tanstack/react-router";

import MinimumNotMetConfirmation from "./-components/MinimumNotMetConfirmation";

export const Route = createFileRoute("/_unauthenticated/signup-interest-confirmation")({
  component: MinimumNotMetConfirmation,
});
